import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Buildings, Brain, ChartBar, ForkKnife, User, GearSix } from '@phosphor-icons/react';

const NOVA_LOGO = "https://customer-assets.emergentagent.com/job_nova-fit-meals/artifacts/8r5uywp4_Nova%20Foods.png";

const Header = ({ user }) => {
  const handleLogin = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = encodeURIComponent(window.location.origin + '/auth/google/callback');
    const scope = encodeURIComponent('openid email profile');
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&access_type=offline&prompt=consent`;
  };

  return (
    <header className="sticky top-0 z-50 bg-stone-50/90 backdrop-blur-xl border-b border-stone-200/50" data-testid="header">
      <div className="px-6 md:px-12 lg:px-24 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-heading text-2xl font-semibold text-[#1A4331]" data-testid="logo-link">
          <img src={NOVA_LOGO} alt="Nova Foods" className="h-10 w-10 rounded-lg object-cover" />
          Nova Foods
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="nav-menu">
          {user ? (
            <>
              <Link to="/dashboard" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="dashboard-link">
                Dashboard
              </Link>
              <Link to="/corporate" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="corporate-link">
                Corporate
              </Link>
              <Link to="/fitness" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="fitness-link">
                Fitness
              </Link>
              <Link to="/plans" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="plans-link">
                Plans
              </Link>
              <Link to="/meals" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="meals-link">
                Menu
              </Link>
              <Link to="/wellness" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="header-wellness-link">
                Wellness
              </Link>
              <Link to="/profile" className="flex items-center gap-2 text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="profile-link">
                <User size={20} weight="duotone" />
                Profile
              </Link>
              {user.role === 'admin' && (
                <Link to="/admin" className="flex items-center gap-2 text-[#C05C3D] hover:text-[#D96A47] font-medium transition-colors" data-testid="admin-link">
                  <GearSix size={20} weight="duotone" />
                  Admin
                </Link>
              )}
            </>
          ) : (
            <>
              <a href="#services" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors">Services</a>
              <Link to="/wellness" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors" data-testid="header-wellness-guest">Wellness</Link>
              <a href="#about" className="text-stone-600 hover:text-[#1A4331] font-medium transition-colors">About</a>
            </>
          )}
        </nav>

        <div className="flex items-center gap-4">
          {user ? (
            <div className="flex items-center gap-3" data-testid="user-info">
              <img src={user.picture || 'https://via.placeholder.com/40'} alt={user.name} className="w-10 h-10 rounded-full border-2 border-[#1A4331]" />
              <span className="hidden md:block font-medium text-stone-700">{user.name}</span>
            </div>
          ) : (
            <button
              onClick={handleLogin}
              className="bg-[#1A4331] text-white px-6 py-3 rounded-full font-medium hover:bg-[#2A5A44] transition-all duration-200"
              data-testid="login-button"
            >
              Get Started
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
